import Landing from "../components/landing/Landing";
import Testimonials from "../components/common_components/testimonials-program/Testimonials";
import SuggestPrograms from "../components/suggest-programs/SuggestPrograms";
import BreakthroughPrograms from "../components/breakthrough-programs/BreakthroughPrograms";
import Leadership from "../components/leadership-courses/LeadershipCourses";
import TrustedWomens from "../components/trusted-womens/TrustedWomens";
import EventRegistration from "../components/events-registration/EventRegistration";
import { appLevelConstants } from "../constants/AppLevelConstants";
import WhatDiffNew from "../components/what-diff-new/WhatDiff";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Glimpses from "../components/glimpses/Glimpses";
import React, { useRef } from "react";
import Review from "../components/google-review/Review";
import { Helmet } from "react-helmet";
import LandingCarousel from "../components/landing-carousel/LandingCarousel";
import { urls } from "../utils/urls";

export default function Home() {
  const sectionRef = useRef(null);

  const handleSucess = (messageGIT) => {
    toast.success(messageGIT, {
      position: toast.POSITION.TOP_RIGHT,
      limit: 1,
      autoClose: 5000,
      hideProgressBar: false,
      newestOnTop: false,
      rtl: false,
      containerId: 'getInTouch'
    });
  };
  const handleError = (messageGIT) => {
    toast.error(messageGIT, {
      position: toast.POSITION.TOP_RIGHT,
      limit: 1,
      autoClose: 5000,
      hideProgressBar: false,
      newestOnTop: false,
      rtl: false,
      containerId: 'getInTouch'
    });
  };

  return (
    <>
      <Helmet> 
        <title>Iron Lady - Enabling A Million Women to Reach the Top | Top Leadership Programs for Women</title> 
        <meta name="description" content="Discover the top leadership program for women at Iron Lady. Transform your career with expert-led courses designed to build strategic leadership skills, boost confidence, and accelerate professional growth. Join now and lead with impact!" /> 
      </Helmet>

      {/* <Landing handleSucess={handleSucess} handleError={handleError} /> */}
      <LandingCarousel />
      {/* <EventRegistration /> */}
      <div ref={sectionRef} id="section2">
        <WhatDiffNew data={appLevelConstants.aboutUs.whatDifference} title="Why Choose Iron Lady" buttonId='WhatDiff_Home' handleSucess={handleSucess} handleError={handleError} />
      </div>

      <Leadership />
      <TrustedWomens />
      <Testimonials data={appLevelConstants.testimonialsHome} title="Same stories are used for 100BM and C-Suite league" buttonId='testimonials_Home' />
      <SuggestPrograms handleSucess={handleSucess} handleError={handleError} buttonId='suggestedPrograms_Home'></SuggestPrograms>
      <BreakthroughPrograms handleSucess={handleSucess} handleError={handleError}></BreakthroughPrograms>
      <Glimpses />
      <Review />
      <ToastContainer limit={1}
        position="bottom-right"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        containerId={'getInTouch'}
        enableMultiContainer
      />
    </>
  );
}
